import * as api from 'common/api'

// 人员列表
export let list = params => api.get('account/school/teacher/list', params)
// 获取人员信息
export let get = params => api.get('account/school/teacher/edit', params)
// 创建人员/修改人员信息
export let edit = channel => api.post('account/school/teacher/edit', channel)
// 批量导入教师
export let batch_import = params => api.post('account/school/teacher/batch', params)

export async function roles () {
  return [
    {name: '教师', en_name: 'teacher'},
    {name: '管理', en_name: 'manager'},
    {name: '校长', en_name: 'president'},
  ]
}



// WEBPACK FOOTER //
// ./src/api/teacher.js